import baseViewSelector from './my_account_base_view_selector'
import profileViewSelector from './my_account_profile_view_selector'
import advancedViewSelector from './my_account_advanced_view_selector'
import notificationsViewSelector from './my_account_notifications_view_selector'
import profilePictureSelector from './my_account_profile_picture_selector'
import saveIconSelector from './my_account_save_icon_selector'
import myAccountConfirmPasswordSelector from './my_account_confirm_password_selector'

export default {
	baseViewSelector,
	profileViewSelector,
	advancedViewSelector,
	notificationsViewSelector,
	profilePictureSelector,
	saveIconSelector,
	myAccountConfirmPasswordSelector,
}
